import React from "react";

import { NavBarContext, useNavBarTitle } from "./hooks";

export { useNavBarTitle, NavBarContext } from "./hooks";

export const NavBarProvider = ({ children }: { children: React.ReactNode }) => {
  const [navTitle, setNavTitle] = React.useState<React.ReactNode>("");
  const [navBarStyle, setNavBarStyle] = React.useState("");
  return (
    <NavBarContext.Provider
      value={{ navTitle, setNavTitle, navBarStyle, setNavBarStyle }}
    >
      {children}
    </NavBarContext.Provider>
  );
};

const NavBarTitle = ({ title }: { title: React.ReactNode }) => {
  useNavBarTitle(title);
  return null;
};

export default NavBarTitle;
